import React from 'react';

import StarsWizard from '@swf/components/StarsWizard/StarsWizard';
import Translation from '@swf/components/Translation/Translation';
import { useIsMobileDevice } from '@swf/poker';

import Banner from '../../Modal/Banner/Banner';

import { TXTCLI_Tournament, TXTMOB_Create } from './CreateTournamentBanner.messages.json';
import styles from './CreateTournamentBanner.scss';

const Title = () => (
  <>
    <Translation {...TXTMOB_Create} />
    <br />
    <Translation {...TXTCLI_Tournament} />
  </>
);

const CreateTournamentBanner = () => {
  const isMobileDevice = useIsMobileDevice(true);

  return isMobileDevice ? (
    <StarsWizard.Page name="CreateTournamentBanner">
      <Banner title={<Title />} className={styles.bannerBg} />
    </StarsWizard.Page>
  ) : (
    <Banner title={<Title />} className={styles.bannerBg} />
  );
};

CreateTournamentBanner.displayName = 'CreateTournamentBanner';

export default CreateTournamentBanner;
